import { render, staticRenderFns } from "./AtTheRateIcon.vue?vue&type=template&id=20d93136"
import script from "./AtTheRateIcon.vue?vue&type=script&lang=js"
export * from "./AtTheRateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports